import { useContext, useEffect, useState } from 'react'
import {
  SET_SELECTED_TEST_ZONE_DATA,
  SET_TEST_ZONE_DATA,
  SHOW_TEST_ZONE_FORM,
  TestZoneContext,
} from './context/context'
import Button from '../../common/Button'
import LinkWithStatus from '../../common/LinkWithStatus'
import InputText from '../../common/InputText'
import NoRecordsFound from '../../common/NoRecordsFound'
import Tooltip from '../../common/tooltip'
import { Edit, TrashAlt } from '@styled-icons/boxicons-solid'
import { deleteRequest, getRequest } from '../../../services/base'
import Pagination from '../../common/Pagination'
import TestZoneForm from './form'
import { NavContext } from '../../../context/global_context'
import { downloadFileBlob } from '../../../utils/common'

const TestZoneRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-3/12 pl-10 items-center table_text">
          <Tooltip message={props.plant?.name}>
            <div>{props.plant?.name}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          <Tooltip message={props?.specifier}>
            <div>{props.specifier}</div>
          </Tooltip>
        </div>
        <div className="flex w-4/12 pl-6 items-center table_text">
          <Tooltip message={props?.description}>
            <div>{props.description}</div>
          </Tooltip>
        </div>

        <div className="flex w-2/12 pl-6 justify-end ">
          <div>
            <span
              onClick={() => {
                props.onEdit()
              }}
              className="cursor-pointer p-2"
            >
              <Edit size="2rem" color="#0189E9" />
            </span>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <TrashAlt size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const TestZones = () => {
  const [state, dispatch] = useContext(TestZoneContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({})

  useEffect(() => {
    getTestZones('', true)
  }, [])

  const getTestZones = async (url = null, showLoader = false) => {
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Fetching Test Zones Data',
          showLoader: true,
        },
        notification: {},
      })
    }

    let res = await getRequest(
      url ? url : `/api/test_zone/?search=${searchValue}`
    )
    dispatch({ type: SET_TEST_ZONE_DATA, data: res.results })
    setPagination(res.pagination)
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
    }
  }

  const deleteTestZones = async (id, specifier) => {
    if (
      window.confirm(`Are you sure want to delete selected ${specifier}`) ===
      true
    ) {
      let res = await deleteRequest(`/api/test_zone/${id}/`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Test Zones Deleted Successfully`,
        },
      })
      getTestZones('', false)
    }
  }

  const downloadTestZone = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Downloading Test Zone csv file is in progress.`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(`/api/test_zone/download/`, true, true)
    if (res?.msg) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `test_zones.csv`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  return (
    <div>
      <TestZoneForm
        getTestZoneList={() => {
          getTestZones('', false)
        }}
      />
      <form
        className="flex flex-col w-full space-y-2 pb-5"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div className="flex space-x-5">
          <div className="flex w-6/12 font-light text-right space-x-5">
            <InputText
              name="search"
              value={searchValue}
              type="text"
              placeholder={`Enter To Search Test Zones`}
              onChange={(e) => {
                setSearchValue(e)
              }}
              wrapperClass={`p-0`}
              isFullSize={false}
              className="h-10 px-5 pr-5"
              isRequired={false}
            />
            <Button
              className={`bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded`}
              onClick={() => {
                getTestZones('', true)
              }}
              text="Search"
            />
          </div>
          <div className="flex w-6/12 font-light text-right space-x-5 justify-end">
            <LinkWithStatus
              href={`/administration/test_zone/export`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Export Test Zones"
              onClickFunc={() => {
                downloadTestZone()
              }}
            />
            <LinkWithStatus
              href={`/administration/test_zone/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New Test Zone"
              onClickFunc={() => {
                dispatch({
                  type: SHOW_TEST_ZONE_FORM,
                  showFormPopup: true,
                  data: {},
                })
              }}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-3/12 pl-10 items-center">Plant</div>
          <div className="flex w-3/12 pl-6 items-center">Specifier</div>
          <div className="flex w-4/12 pl-6 items-center">Description</div>
          <div className="w-2/12 pl-6"></div>
        </div>
      </div>
      {state?.data?.map((test_zone, index) => {
        return (
          <TestZoneRow
            key={`test-zone-${test_zone.id}-${index}`}
            {...test_zone}
            onEdit={() => {
              dispatch({
                type: SET_SELECTED_TEST_ZONE_DATA,
                data: { ...test_zone, index: index },
              })
            }}
            onDelete={() => {
              deleteTestZones(test_zone.id, test_zone.specifier)
            }}
          />
        )
      })}
      {state?.data?.length < 1 && <NoRecordsFound />}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            getTestZones(e, true)
          }}
          onClickPrev={(e) => {
            getTestZones(e, true)
          }}
        />
      </div>
    </div>
  )
}

export default TestZones
